import React, { Component } from 'react';
import { Link } from 'react-router';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import Select2 from 'react-select2-wrapper';
import {
  getSurgeons,
  getHospitals
} from '../../utils/db';
import withDerFilter from '../../common/withCaseFilter';
import withTableName from '../../common/withTableName';
import withDerSearchFilter from '../../common/withDerSearchFilter';
import {
  sortData, Years, Months, Days
} from '../../common/globals';
import Bugsnag from '../../helpers/bugsnag';

class DersFilter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      Hospital: [],
      Surgeon: [],
      Patient: '',
      hospitals: [],
      surgeons: [],
      patients: [],
      Product: '',
      DerNo: '',
      CaseNo: '',
      ComNo: '',
      Year: '',
      Month: '',
      Day: '',
      years: [],
      months: [],
      days: [],
      clearData: {},
      filterHospitalData: '',
      filterSurgeonData: '',
      hospitalSearchResult: [],
      surgeonSearchResult: [],
      isSearchHospital: false,
      isSearchSurgeon: false,
      KeywordSearch: []
    };
  }

  _onClearFilter = () => {
    try {
      const { onClearFilter } = this.props;
      this.setState({
        Hospital: [],
        Surgeon: [],
        KeywordSearch: [],
        clearData: {},
        Patient: '',
        Product: '',
        DerNo: '',
        CaseNo: '',
        ComNo: '',
        Year: '',
        Month: '',
        Day: ''
      });
      onClearFilter();
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

    _onUnSelectHospital = async (id) => {
      try {
        let { Hospital } = this.state;
        if (Hospital.includes(id)) {
          Hospital = Hospital.filter((val) => val !== id);
          this._onFilter({ Hospital });
          this.setState({ Hospital }, () => {
            this.setClearFilter();
          });
        }
      } catch (e) {
        Bugsnag.notify(e);
      }
    };

    _onSelectHospital = async (id) => {
      try {
        const { Hospital } = this.state;
        if (Hospital.indexOf(id) > -1) {
          Hospital.splice(Hospital.indexOf(id), 1);
        } else {
          Hospital.push(id);
          this._onFilter({ Hospital: JSON.stringify(Hospital) });
        }
        this.setState({ Hospital }, () => {
          this.setClearFilter();
        });
      } catch (e) {
        Bugsnag.notify(e);
      }
    };

    _onUnSelectSurgeon = async (id) => {
      try {
        let { Surgeon } = this.state;
        if (Surgeon.includes(id)) {
          Surgeon = Surgeon.filter((val) => val !== id);
          this.setState({ Surgeon }, () => {
            this.setClearFilter();
          });
          this._onFilter({ Surgeon });
        }
      } catch (e) {
        Bugsnag.notify(e);
      }
    };

    _onSelectSurgeon = async (id) => {
      try {
        const { Surgeon } = this.state;
        if (Surgeon.indexOf(id) > -1) {
          Surgeon.splice(Surgeon.indexOf(id), 1);
        } else {
          Surgeon.push(id);
          this._onFilter({ Surgeon: JSON.stringify(Surgeon) });
        }
        this.setState({ Surgeon }, () => {
          this.setClearFilter();
        });
      } catch (e) {
        Bugsnag.notify(e);
      }
    };

    _onUnSelectPatient = async (id) => {
      try {
        let { Patient } = this.state;
        if (Patient.includes(id)) {
          Patient = Patient.filter((val) => val !== id);
          this.setState({ Patient }, () => {
            this.setClearFilter();
          });
        }
      } catch (e) {
        Bugsnag.notify(e);
      }
    };

    _onSelectPatient = async ({ params: { data: { id } } }) => {
      try {
        const { Patient } = this.state;
        if (!Patient.includes(id)) {
          Patient.push(id);
          await this.setState({ Patient }, () => {
            this.setClearFilter();
          });
          this._onFilter({ Patient });
        }
      } catch (e) {
        Bugsnag.notify(e);
      }
    };

    _onFilter = (data) => {
      try {
        const { onFilter, previousData } = this.props;
        onFilter(Object.assign(previousData, data));
      } catch (e) {
        Bugsnag.notify(e);
      }
    }

  _onDerNo = (event) => {
    try {
      this.setState({ DerNo: event.target.value !== '' ? event.target.value : '' }, () => {
        this.setClearFilter();
        this._onFilter({ DerNo: this.state.DerNo });
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onCase = (event) => {
    try {
      this.setState({ CaseNo: event.target.value !== '' ? event.target.value : '' }, () => {
        this.setClearFilter();
        this._onFilter({ CaseNo: this.state.CaseNo });
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onCom = (event) => {
    try {
      this.setState({ ComNo: event.target.value !== '' ? event.target.value : '' }, () => {
        this.setClearFilter();
        this._onFilter({ ComNo: this.state.ComNo });
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onYear = (value) => {
    try {
      this.setState({ Year: value !== '' ? value : '' }, () => {
        this.setClearFilter();
        this._onFilter({ Year: this.state.Year });
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onMonth = (value) => {
    try {
      this.setState({ Month: value !== '' ? value : '' }, () => {
        this.setClearFilter();
        this._onFilter({ Month: value });
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onDay = (value) => {
    try {
      this.setState({ Day: value !== '' ? value : '' }, () => {
        this.setClearFilter();
        this._onFilter({ Day: value });
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onPatientID = (event) => {
    try {
      this.setState({ Patient: event.target.value !== '' ? event.target.value : '' }, () => {
        this.setClearFilter();
        this._onFilter({ Patient: this.state.Patient });
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onProduct = (event) => {
    try {
      this.setState({ Product: event.target.value !== '' ? event.target.value : '' }, () => {
        this.setClearFilter();
        this._onFilter({ Product: this.state.Product });
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onKeyword = (event) => {
    try {
      let keywordData = [];
      this.setState({ KeywordSearch: event.target.value !== '' ? event.target.value : [] }, () => {
        keywordData = this.state.KeywordSearch.length > 0 ? this.state.KeywordSearch.split(',') : [];
        this.setClearFilter();
        this._onFilter({ Keyword: JSON.stringify(keywordData) });
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onClear = (value) => {
    try {
      const {
        Hospital, Surgeon, Patient, Product, DerNo, CaseNo, ComNo,
        Year, Month, Day, KeywordSearch
      } = this.state;
      this._onFilter({
        Hospital: value === 'Hospital' ? [] : Hospital,
        Surgeon: value === 'Surgeon' ? [] : Surgeon,
        Keyword: value === 'KeywordSearch' ? [] : KeywordSearch,
        Patient: value === 'Patient' ? '' : Patient,
        Product: value === 'Product' ? '' : Product,
        DerNo: value === 'DerNo' ? '' : DerNo,
        CaseNo: value === 'CaseNo' ? '' : CaseNo,
        ComNo: value === 'ComNo' ? '' : ComNo,
        Year: value === 'Year' ? '' : Year,
        Month: value === 'Month' ? '' : Month,
        Day: value === 'Day' ? '' : Day,
      });
      this.setState({
        Hospital: value === 'Hospital' ? [] : Hospital,
        Surgeon: value === 'Surgeon' ? [] : Surgeon,
        KeywordSearch: value === 'KeywordSearch' ? [] : KeywordSearch,
        Patient: value === 'Patient' ? '' : Patient,
        Product: value === 'Product' ? '' : Product,
        DerNo: value === 'DerNo' ? '' : DerNo,
        CaseNo: value === 'CaseNo' ? '' : CaseNo,
        ComNo: value === 'ComNo' ? '' : ComNo,
        Year: value === 'Year' ? '' : Year,
        Month: value === 'Month' ? '' : Month,
        Day: value === 'Day' ? '' : Day,
      }, () => {
        this.setClearFilter();
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  setClearFilter = () => {
    try {
      const {
        Hospital, Surgeon, Patient, Product, DerNo, CaseNo, ComNo, Year,
        Month, Day, KeywordSearch,
      } = this.state;
      let clearData = {};
      if (Hospital.length > 0) {
        clearData = Object.assign(clearData, { Hospital });
      }
      if (Surgeon.length > 0) {
        clearData = Object.assign(clearData, { Surgeon });
      }
      if (!isEmpty(Patient)) {
        clearData = Object.assign(clearData, { Patient });
      }
      if (!isEmpty(Product)) {
        clearData = Object.assign(clearData, { Product });
      }
      if (!isEmpty(DerNo)) {
        clearData = Object.assign(clearData, { DerNo });
      }
      if (!isEmpty(CaseNo)) {
        clearData = Object.assign(clearData, { CaseNo });
      }
      if (!isEmpty(ComNo)) {
        clearData = Object.assign(clearData, { ComNo });
      }
      if (!isEmpty(Year)) {
        clearData = Object.assign(clearData, { Year });
      }
      if (!isEmpty(Month)) {
        clearData = Object.assign(clearData, { Month });
      }
      if (!isEmpty(Day)) {
        clearData = Object.assign(clearData, { Day });
      }
      if (KeywordSearch.length > 0) {
        clearData = Object.assign(clearData, { KeywordSearch });
      }
      this.setState({ clearData });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

    _onHospitalChange = (value) => {
      try {
        // eslint-disable-next-line react/prop-types
        const { setDerSearchFilter, derSearchFilter } = this.props;
        this.setState({ filterHospitalData: value }, () => {
          setDerSearchFilter({
            ...derSearchFilter, filterHospitalData: value
          });
          this._onSearchHospitalList();
        });
      } catch (error) {
        Bugsnag.notify(error);
      }
    }

    _onSearchHospitalList = () => {
      try {
        const { filterHospitalData, hospitalSearchResult } = this.state;
        const searchRes = [];
        const searchData = new RegExp(filterHospitalData.toUpperCase(), 'g');
        const data = hospitalSearchResult.filter((item) => item.CustomerName.match(searchData));
        data.map((item) => {
          searchRes.push(item);
        });
        this.setState({
          hospitals: filterHospitalData !== '' ? searchRes : hospitalSearchResult
        });
      } catch (e) {
        Bugsnag.notify(e);
      }
    }

    _onSearchHospital = () => {
      const { isSearchHospital } = this.state;
      // eslint-disable-next-line react/prop-types
      const { setDerSearchFilter } = this.props;
      if (isSearchHospital) {
        this.setState({ filterRepData: '' }, () => {
          this._onHospitalChange('');
        });
      }
      this.setState({ isSearchHospital: !isSearchHospital });
      setDerSearchFilter({ isSearchHospital: !isSearchHospital });
    }

    _onSurgeonChange = (value) => {
      try {
        // eslint-disable-next-line react/prop-types
        const { setDerSearchFilter, derSearchFilter } = this.props;
        this.setState({ filterSurgeonData: value }, () => {
          setDerSearchFilter({
            ...derSearchFilter, filterSurgeonData: value
          });
          this._onSearchSurgeonList();
        });
      } catch (error) {
        Bugsnag.notify(error);
      }
    }

    _onSearchSurgeonList = () => {
      try {
        const { filterSurgeonData, surgeonSearchResult } = this.state;
        const searchRes = [];
        const searchData = new RegExp(filterSurgeonData.toUpperCase(), 'g');
        const data = surgeonSearchResult.filter((item) => item.SurgeonName.match(searchData));
        data.map((item) => {
          searchRes.push(item);
        });
        this.setState({
          surgeons: filterSurgeonData !== '' ? searchRes : surgeonSearchResult
        });
      } catch (e) {
        Bugsnag.notify(e);
      }
    }

    _onSearch = (value) => {
      try {
        const {
          isSearchHospital,
          isSearchSurgeon,
          filterHospitalData,
          filterSurgeonData,
        } = this.state;
        // eslint-disable-next-line react/prop-types
        const { setDerSearchFilter } = this.props;
        this.setState({
          isSearchHospital: value === 'isSearchHospital' ? !isSearchHospital : false,
          isSearchSurgeon: value === 'isSearchSurgeon' ? !isSearchSurgeon : false,
          filterHospitalData: value === 'isSearchHospital' ? '' : filterHospitalData,
          filterSurgeonData: value === 'isSearchSurgeon' ? '' : filterSurgeonData,
        }, () => {
          value === 'isSearchHospital' && this._onHospitalChange('');
          value === 'isSearchSurgeon' && this._onSurgeonChange('');
        });
        setDerSearchFilter({
          isSearchHospital: value === 'isSearchHospital' ? !isSearchHospital : false,
          isSearchSurgeon: value === 'isSearchSurgeon' ? !isSearchSurgeon : false,
        });
      } catch (e) {
        Bugsnag.notify(e);
      }
    }

    _onFilterData = () => {
      try {
        const { derSearchFilter } = this.props;
        this.setState({
          filterHospitalData: derSearchFilter.filterHospitalData !== undefined ? derSearchFilter.filterHospitalData : '',
          filterSurgeonData: derSearchFilter.filterSurgeonData !== undefined ? derSearchFilter.filterSurgeonData : '',
        }, () => {
          derSearchFilter.filterHospitalData !== undefined ? this._onSearchHospitalList() : '';
          derSearchFilter.filterSurgeonData !== undefined ? this._onSearchSurgeonList() : '';
        });
      } catch (e) {
        Bugsnag.notify(e);
      }
    }

    async UNSAFE_componentWillMount() {
      try {
        const { selectedFilter, derSearchFilter } = this.props;
        const surgeonsRes = await getSurgeons();
        const sortSurgeons = sortData(surgeonsRes, 'SurgeonName');
        const hospitalRes = await getHospitals();
        const sortHospital = sortData(hospitalRes, 'CustomerName');
        this.setState({
          surgeons: sortSurgeons,
          surgeonSearchResult: sortSurgeons,
          years: Years,
          months: Months,
          days: Days,
          isSearchSurgeon: derSearchFilter.isSearchSurgeon !== undefined ? derSearchFilter.isSearchSurgeon : '',
          hospitals: sortHospital,
          hospitalSearchResult: sortHospital,
          isSearchHospital: derSearchFilter.isSearchHospital !== undefined ? derSearchFilter.isSearchHospital : '',
          Hospital: (selectedFilter.hasOwnProperty('Hospital'))
            ? selectedFilter.Hospital
            : [],
          Surgeon: (selectedFilter.hasOwnProperty('Surgeon'))
            ? selectedFilter.Surgeon
            : [],
          Patient: (selectedFilter.hasOwnProperty('Patient'))
            ? (selectedFilter.Patient)
            : [],
          Product: (selectedFilter.hasOwnProperty('Product'))
            ? (selectedFilter.Product)
            : '',
          DerNo: (selectedFilter.hasOwnProperty('DerNo'))
            ? (selectedFilter.DerNo)
            : '',
          CaseNo: (selectedFilter.hasOwnProperty('CaseNo'))
            ? (selectedFilter.CaseNo)
            : '',
          ComNo: (selectedFilter.hasOwnProperty('ComNo'))
            ? (selectedFilter.ComNo)
            : '',
          Year: (selectedFilter.hasOwnProperty('Year'))
            ? (selectedFilter.Year)
            : '',
          Month: (selectedFilter.hasOwnProperty('Month'))
            ? (selectedFilter.Month)
            : '',
          Day: (selectedFilter.hasOwnProperty('Day'))
            ? (selectedFilter.Day)
            : '',
          KeywordSearch: (selectedFilter.hasOwnProperty('Keyword'))
            ? JSON.parse(selectedFilter.Keyword)
            : [],
        }, () => {
          this._onFilterData();
        });
        this.setClearFilter();
      } catch (e) {
        Bugsnag.notify(e);
      }
    }

    render() {
      const {
        Hospital, Surgeon, Patient, hospitals, surgeons, Product, DerNo, CaseNo, KeywordSearch,
        ComNo, filterHospitalData, isSearchHospital, filterSurgeonData, isSearchSurgeon, clearData,
        years, Year, months, Month, days, Day
      } = this.state;
      const { title, filter, derSearchFilter } = this.props;
      const {
        patient = false
      } = filter;

      return (
        <section className="filter-section">
          <div className="container">
            <div className="top-block">
              <div className="row">
                <div className="col">
                  <h4>{title}</h4>
                </div>
                <div className="col-auto text-end">
                  <Link
                    className={`${Object.keys(clearData).length > 0 ? 'cursor-pointer' : 'btn-clear-filter'}`}
                    onClick={Object.keys(clearData).length > 0 ? this._onClearFilter : () => {}}
                  >Clear Search
                  </Link>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <div className="accordion accordion-flush accordion-filter" id="accordionFilter">
                  <div className="accordion-item" style={{ borderBottom: '0' }}>
                    <div className="accordion-header" id="headingNine">
                      { !isEmpty(DerNo)
                          && (
                          <Link
                            className="btn btn-link" onClick={() => this._onClear('DerNo')}
                          >Clear
                          </Link>
                          )}
                      <button
                        className="button collapsed-remove" type="button"
                      >
                        DER #
                      </button>
                    </div>
                    <div
                      id="collapseNine" className="accordion-collapse collapse show"
                    >
                      <div className="accordion-body pt-0 pb-2">
                        <input
                          type="text"
                          className="form-control search-input search-input-focus"
                          onChange={((event) => {
                            this._onDerNo(event);
                          })}
                          placeholder="Search DER #"
                          value={DerNo}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item" style={{ border: '0' }}>
                    <div className="accordion-header" id="headingNine">
                      { !isEmpty(CaseNo)
                          && (
                          <Link
                            className="btn btn-link" onClick={() => this._onClear('CaseNo')}
                          >Clear
                          </Link>
                          )}
                      <button
                        className="button collapsed-remove" type="button"
                      >
                        Case #
                      </button>
                    </div>
                    <div
                      id="collapseNine" className="accordion-collapse collapse show"
                    >
                      <div className="accordion-body pt-0 pb-2">
                        <input
                          type="text"
                          className="form-control search-input search-input-focus"
                          onChange={((event) => {
                            this._onCase(event);
                          })}
                          placeholder="Search Case #"
                          value={CaseNo}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item" style={{ border: '0' }}>
                    <div className="accordion-header" id="headingNine">
                      { !isEmpty(ComNo)
                          && (
                          <Link
                            className="btn btn-link" onClick={() => this._onClear('ComNo')}
                          >Clear
                          </Link>
                          )}
                      <button
                        className="button collapsed-remove" type="button"
                      >
                        PC #
                      </button>
                    </div>
                    <div
                      id="collapseNine" className="accordion-collapse collapse show"
                    >
                      <div className="accordion-body pt-0 pb-2">
                        <input
                          type="text"
                          className="form-control search-input search-input-focus"
                          onChange={((event) => {
                            this._onCom(event);
                          })}
                          placeholder="Search PC #"
                          value={ComNo}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item" style={{ border: '0' }}>
                    <div className="accordion-header" id="headingNine">
                      { !isEmpty(Year)
                          && (
                          <Link
                            className="btn btn-link" onClick={() => this._onClear('Year')}
                          >Clear
                          </Link>
                          )}
                      <button
                        className="button collapsed-remove" type="button"
                      >
                        Year
                      </button>
                    </div>
                    <div
                      id="collapseNine" className="accordion-collapse collapse show"
                    >
                      <div className="accordion-body pt-0 pb-2">
                        <Select2
                          style={{ width: '100%', color: 'red' }}
                          className="form-control"
                          data={years.map((value) => (value))}
                          onChange={({ target: { value } }) => {
                            this.setState({ Year: value }, () => {
                              this._onYear(value);
                            });
                          }}
                          value={Year}
                          options={{ placeholder: 'Search Year' }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item" style={{ border: '0' }}>
                    <div className="accordion-header" id="headingNine">
                      { !isEmpty(Month)
                          && (
                          <Link
                            className="btn btn-link" onClick={() => this._onClear('Month')}
                          >Clear
                          </Link>
                          )}
                      <button
                        className="button collapsed-remove" type="button"
                      >
                        Month
                      </button>
                    </div>
                    <div
                      id="collapseNine" className="accordion-collapse collapse show"
                    >
                      <div className="accordion-body pt-0 pb-2">
                        <Select2
                          style={{ width: '100%', color: 'red' }}
                          className="form-control"
                          data={months}
                          onSelect={({ params: { data: { id } } }) => {
                            this.setState({ Month: id }, () => {
                              this._onMonth(id);
                            });
                          }}
                          value={Month}
                          options={{ placeholder: 'Search Month' }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item" style={{ border: '0' }}>
                    <div className="accordion-header" id="headingNine">
                      { !isEmpty(Day)
                          && (
                          <Link
                            className="btn btn-link" onClick={() => this._onClear('Day')}
                          >Clear
                          </Link>
                          )}
                      <button
                        className="button collapsed-remove" type="button"
                      >
                        Day
                      </button>
                    </div>
                    <div
                      id="collapseNine" className="accordion-collapse collapse show"
                    >
                      <div className="accordion-body pt-0 pb-2">
                        <Select2
                          style={{ width: '100%', color: 'red' }}
                          className="form-control"
                          data={days.map((value) => (value))}
                          onChange={({ target: { value } }) => {
                            this.setState({ Day: value }, () => {
                              this._onDay(value);
                            });
                          }}
                          value={Day}
                          options={{ placeholder: 'Search Day' }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item" style={{ border: '0' }}>
                    <div className="accordion-item" style={{ borderTop: '0' }}>
                      <div className="accordion-header" id="headingThree">
                        { (Hospital.length > 0 && !isSearchHospital)
                          && (
                          <Link
                            className="btn btn-link" onClick={() => this._onClear('Hospital')}
                          >Clear
                          </Link>
                          )}
                        <button
                          className={`${!derSearchFilter.isSearchHospital ? 'accordion-button collapsed' : 'accordion-button'}`}
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseThree" aria-expanded="false"
                          aria-controls="collapseThree"
                          onClick={() => this._onSearch('isSearchHospital')}
                        >
                          Hospital
                        </button>
                      </div>
                      <div
                        id="collapseThree"
                        className={`${!derSearchFilter.isSearchHospital ? 'accordion-collapse collapse' : 'accordion-collapse collapse show'}`}
                        aria-labelledby="headingThree"
                        data-bs-parent="#accordionFilter"
                      >
                        <div className="accordion-body pt-0 pb-2">
                          <div className="accordion-body p-0">
                            <input
                              type="text"
                              className="form-control search-input search-input-focus"
                              value={filterHospitalData}
                              onChange={({ target: { value } }) => {
                                this._onHospitalChange(value);
                              }}
                              placeholder="Search Hospital"
                            />
                          </div>
                          {!isEmpty(hospitals) && hospitals.map((item, key) => (
                            <div className="topping day-filter-item" key={key}>
                              <label className="cursor-pointer mt-2">
                                <input
                                  type="checkbox"
                                  onClick={() => this._onSelectHospital(item.CustomerName)}
                                  checked={Hospital.indexOf(item.CustomerName) > -1}
                                  readOnly
                                  id={item.CustomerName}
                                />
                                <span className="me-2" />
                                <a>{item.CustomerName}</a>
                              </label>
                            </div>
                          ))}
                        </div>
                      </div>
                      {
                        !isSearchHospital && hospitals.map((hospital, index) => (
                          <div key={index}>
                            {Hospital.includes(hospital.CustomerName) && (
                            <div className="selection">
                              <p>{hospital.CustomerName}</p>
                              <button className="btn" onClick={() => this._onUnSelectHospital(hospital.CustomerName)}>
                                <i className="fas fa-times" />
                              </button>
                            </div>
                            )}
                          </div>
                        ))
                    }
                    </div>
                    <div className="accordion-item">
                      <div className="accordion-header" id="headingFour">
                        { (Surgeon.length > 0 && !isSearchSurgeon)
                          && (
                          <Link
                            className="btn btn-link" onClick={() => this._onClear('Surgeon')}
                          >Clear
                          </Link>
                          )}
                        <button
                          className={`${!derSearchFilter.isSearchSurgeon ? 'accordion-button collapsed' : 'accordion-button'}`}
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseFour" aria-expanded="false"
                          aria-controls="collapseFour"
                          onClick={() => this._onSearch('isSearchSurgeon')}
                        >
                          Surgeon
                        </button>
                      </div>
                      <div
                        id="collapseFour"
                        className={`${!derSearchFilter.isSearchSurgeon ? 'accordion-collapse collapse' : 'accordion-collapse collapse show'}`}
                        aria-labelledby="headingFour"
                        data-bs-parent="#accordionFilter"
                      >
                        <div className="accordion-body pt-0 pb-2">
                          <div className="accordion-body p-0">
                            <input
                              type="text"
                              className="form-control search-input search-input-focus"
                              value={filterSurgeonData}
                              onChange={({ target: { value } }) => {
                                this._onSurgeonChange(value);
                              }}
                              placeholder="Search Surgeon"
                            />
                          </div>
                          {!isEmpty(surgeons) && surgeons.map((item, key) => (
                            <div className="topping day-filter-item" key={key}>
                              <label className="cursor-pointer mt-2">
                                <input
                                  type="checkbox"
                                  onClick={() => this._onSelectSurgeon(item.SurgeonName)}
                                  checked={Surgeon.indexOf(item.SurgeonName) > -1}
                                  readOnly
                                  id={item.SurgeonName}
                                />
                                <span className="me-2" />
                                <a>{item.SurgeonName}</a>
                              </label>
                            </div>
                          ))}
                        </div>
                      </div>
                      {
                        !isSearchSurgeon && surgeons.map((surgeon, index) => (
                          <div key={index}>
                            {Surgeon.includes(surgeon.SurgeonName) && (
                            <div className="selection">
                              <p>{surgeon.SurgeonName}</p>
                              <button className="btn" onClick={() => this._onUnSelectSurgeon(surgeon.SurgeonName)}>
                                <i className="fas fa-times" />
                              </button>
                            </div>
                            )}
                          </div>
                        ))
                    }
                    </div>
                    {patient && (
                    <div className="accordion-item" style={{ border: '0' }}>
                      <div className="accordion-header" id="headingNine">
                        { !isEmpty(Patient)
                            && (
                            <Link
                              className="btn btn-link" onClick={() => this._onClear('Patient')}
                            >Clear
                            </Link>
                            )}
                        <button
                          className="button collapsed-remove" type="button"
                        >
                          Patient
                        </button>
                      </div>
                      <div
                        id="collapseNine" className="accordion-collapse collapse show"
                      >
                        <div className="accordion-body pt-0 pb-2">
                          <input
                            type="text"
                            className="form-control search-input search-input-focus"
                            onChange={((event) => {
                              this._onPatientID(event);
                            })}
                            placeholder="Search Patient Name"
                            value={Patient}
                          />
                        </div>
                      </div>
                    </div>
                    )}
                    <div className="accordion-item" style={{ border: '0' }}>
                      <div className="accordion-header" id="headingNine">
                        { !isEmpty(Product)
                          && (
                          <Link
                            className="btn btn-link" onClick={() => this._onClear('Product')}
                          >Clear
                          </Link>
                          )}
                        <button
                          className="button collapsed-remove" type="button"
                        >
                          Product Code
                        </button>
                      </div>
                      <div
                        id="collapseNine" className="accordion-collapse collapse show"
                      >
                        <div className="accordion-body pt-0 pb-2">
                          <input
                            type="text"
                            className="form-control search-input search-input-focus"
                            onChange={((event) => {
                              this._onProduct(event);
                            })}
                            placeholder="Search Product Code"
                            value={Product}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="accordion-item">
                      <div className="accordion-header" id="headingSeven">
                        { KeywordSearch.length > 0
                            && (
                            <Link
                              className="btn btn-link" onClick={() => this._onClear('KeywordSearch')}
                            >Clear
                            </Link>
                            )}
                        <button
                          className="button collapsed-remove" type="button"
                        >
                          Keyword (any field)
                        </button>
                      </div>
                      <div
                        id="collapseSeven" className="accordion-collapse collapse show"
                      >
                        <div className="accordion-body pt-0 pb-2">
                          <input
                            type="text"
                            className="form-control search-input search-input-focus"
                            onChange={((event) => {
                              this._onKeyword(event);
                            })}
                            placeholder="Search hospitals, surgeons, patients and product code."
                            value={KeywordSearch}
                          />
                          <p className="note">To search by more than one word, separate each word with a comma. This creates an “AND” search.</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      );
    }
}

DersFilter.propTypes = {
  title: PropTypes.string.isRequired,
  filter: PropTypes.objectOf(PropTypes.bool).isRequired,
  onFilter: PropTypes.func.isRequired,
  previousData: PropTypes.objectOf(PropTypes.any).isRequired,
  selectedFilter: PropTypes.objectOf(PropTypes.any).isRequired,
  onClearFilter: PropTypes.func.isRequired,
  // tableName: PropTypes.string.isRequired,
  derSearchFilter: PropTypes.objectOf(PropTypes.any).isRequired
};

export default withTableName(withDerSearchFilter(withDerFilter(DersFilter)));
